/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react"
import { arrayOf, shape, bool, string, func } from "prop-types"
import { Box } from "@planningcenter/tapestry-react"
import classNames from "classnames"
import DraggableOptionList from "./DraggableOptionList"

const QuestionDropdownOptions = ({
  onAddChoice,
  onUpdateChoice,
  onDeleteChoice,
  onOptionsReorder,
  question
}) => {
  const [newChoice, setNewChoice] = useState("")
  const [editingRow, setEditingRow] = useState(null)

  const handleAddNewChoice = () => {
    if (newChoice.trim().length > 0) {
      onAddChoice(newChoice)
    }
    setNewChoice("")
  }

  const handleRemoveChoice = id => {
    onDeleteChoice(id)
    setNewChoice("")
  }

  const handleKeyDown = e => {
    if (e.code === "Enter") {
      handleAddNewChoice()
      document.getElementById("dropdown_question_option_input").focus()
    }
  }

  const handleRowClick = ({ id }) => {
    setEditingRow(id)
  }

  const handleUpdateChoice = row => {
    onUpdateChoice(row)
    setEditingRow(() => null)
  }

  const maxOptionLength = 80

  return (
    <Box marginTop={2}>
      <label htmlFor="ququestion_option_new_choicee">Options</label>
      <div className="input-btn-lockup input-max-length">
        <input
          type="text"
          id="dropdown_question_option_input"
          name="ququestion_option_new_choicee"
          placeholder="Add an option"
          value={newChoice}
          maxLength={maxOptionLength}
          onChange={e => setNewChoice(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button onClick={handleAddNewChoice} className="btn-solid interaction f-r xs mt-2p">
          Add
        </button>
        <div
          className={classNames("character-count", {
            "count-reached": newChoice.length === maxOptionLength
          })}
        >
          {maxOptionLength - newChoice.length} characters remaining
        </div>
      </div>
      <div className="mt-2 mb-2">
        <DraggableOptionList
          onOptionsReorder={onOptionsReorder}
          options={question.choices}
          editingRow={editingRow}
          onUpdateChoice={handleUpdateChoice}
          onRowClick={handleRowClick}
          onRemoveChoice={handleRemoveChoice}
        />
      </div>
    </Box>
  )
}

QuestionDropdownOptions.propTypes = {
  onDeleteChoice: func,
  onAddChoice: func,
  onUpdateChoice: func,
  onMultipleSelectChange: func,
  onOptionsReorder: func,
  question: shape({ multipleSelect: bool, choices: arrayOf(string) })
}

export default QuestionDropdownOptions
